import React from 'react';
import ReactDOM from 'react-dom';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './assets/scss/custom.scss';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));